import React from 'react'

import { Box, Button, Grid } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { ControlledDatePicker, SplitButton } from 'components/common'
import { ReportTypeButtonsId, ReportTypeButtonValues } from 'constants/EntityConstants'

interface IProps {
  isProcessing: boolean
  onReportButtonClick: (buttonId: ReportTypeButtonsId) => void
  onClearAll: () => void
}

const FilterCriteriaForm = (props: IProps) => {
  const { isProcessing, onReportButtonClick, onClearAll } = props

  const { control } = useFormContext()

  return (
    <Grid container spacing={3}>
      <Grid item xs={2}>
        <ControlledDatePicker control={control} name='start' label='From' />
      </Grid>

      <Grid item xs={2}>
        <ControlledDatePicker control={control} name='end' label='To' />
      </Grid>

      <Grid item xs={6}>
        <Grid container spacing={3} item justifyContent='flex-end'>
          <Grid item>
            <Box display='flex' justifyContent='center'>
              <Button variant='contained' color='grey' onClick={onClearAll}>
                Clear All
              </Button>
            </Box>
          </Grid>

          <Grid item>
            <SplitButton
              options={ReportTypeButtonValues}
              loading={isProcessing}
              onButtonClick={onReportButtonClick}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default FilterCriteriaForm
